import { TopHashtag } from './TopHashtag'
import { withTopHashtag } from './withTopHashtag'

const ConnectedStory = withTopHashtag(TopHashtag)

export { ConnectedStory as TopHashtag }
